import React, { useState } from 'react';
import PropTypes from 'prop-types';

function SearchForm(props) {
  const [value, setValue] = useState('');
  return (
    <form
      className="form-inline search-form"
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        props.onSubmit(value);
      }}
    >
      <input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        className="form-control"
        placeholder={props.placeholder}
        disabled={props.disabled}
      />
      <button className="btn btn-primary">
        <i className="glyphicon glyphicon-search" />
        Search
      </button>
    </form>
  );
}

SearchForm.propTypes = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default SearchForm;
